import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8082/api';
// Origin without the trailing "/api" — used to build absolute media URLs.
export const API_ORIGIN = API_URL.replace(/\/api\/?$/, '');

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config: any) => {
    const token = localStorage.getItem('authToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error: any) => {
    return Promise.reject(error);
});

api.interceptors.response.use((response: any) => {
    let renewedToken = response.headers['x-renewed-token'];
    if (renewedToken) {
        localStorage.setItem('authToken', renewedToken);
    } else {
        renewedToken = response.headers['X-Renewed-Token'];
        if (renewedToken) {
            localStorage.setItem('authToken', renewedToken);
        }
    }
    return response;
}, (error: any) => {
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('authToken');
        if (window.location.pathname.startsWith('/admin') &&
            !window.location.pathname.includes('/admin/login')) {
            window.location.href = '/admin/login';
        }
    }
    return Promise.reject(error);
});

/** Turn a backend media path (e.g. "/api/public/media/file/hero.jpg") into an absolute URL. */
export function mediaUrl(path: string): string {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith('/api')) return API_ORIGIN + path;
    return path;
}

export default api;
